// Ensures that a number is between a minimum and maximum value.
export const clamp = (value: number, min: number, max: number): number => {
  if (value == null) value = 0;
  return Math.min(Math.max(value, min), max);
};

export const roundAwayFromZero = (value: number, decimals: number = 2): number => {
  if (value === 0 || value === null) return 0;
  
  const factor = Math.pow(10, decimals);
  const scaledValue = value * factor;
  
  // Implementation of "Away From Zero" rounding:
  // If the value is positive, we use Math.ceil for the midpoint
  // If the value is negative, we use Math.floor for the midpoint
  const direction = value > 0 ? 1 : -1;
  
  // Handle the midpoint case specifically
  const scaledAbs = Math.abs(scaledValue);
  const isExactlyHalf = Math.abs(scaledAbs - Math.floor(scaledAbs) - 0.5) < Number.EPSILON;
  
  if (isExactlyHalf) {
    // At midpoint, round away from zero
    return direction * Math.ceil(scaledAbs) / factor;
  } else {
    // Not at midpoint, use standard rounding
    return Math.round(scaledValue) / factor;
  }
}

export const numberDecimalSeparator = (locale: string) => {
  // We need a way to determine this that is supported cross-platform.
  const formatted = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(1.1);

  const match = formatted.match(/[^\d]/);
  return match ? match[0] : ".";
}

export const numberGroupSeparator = (locale: string) => {
  // Format a number large enough to trigger grouping, then find the
  // first non-digit character in the output — that's the separator.
  const formatted = new Intl.NumberFormat(locale, {
    useGrouping: true,
    maximumFractionDigits: 0,
  }).format(11000);

  const match = formatted.match(/[^\d]/);
  return match ? match[0] : ",";
};